import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=0234cb40&"
import script from "./LeftBar.vue?vue&type=script&lang=js&"
export * from "./LeftBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports